import withActDetail from "../withActDetail";
import ActDisinfectantForm from "./ActDisinfectantForm";
import ActDisinfectantPDFGenerator from "./ActDisinfectantPDFGenerator";

const actFormKazakhName = 'Дезинфекциялайтын заттардың сынамаларын іріктеу АКТIСI'
const actFormName = 'АКТ отбора проб дезинфицирующих средств'
const actFormNumber = '009'
const actName = 'ActDisinfectant'

export default withActDetail(ActDisinfectantForm, ActDisinfectantPDFGenerator, actFormKazakhName, actFormName, actFormNumber, actName)